/**
 * @property {Function} generate
 * @property {Function} setRoutingData
 */
const Router = require('../../../vendor/friendsofsymfony/jsrouting-bundle/Resources/public/js/router.min.js');
const routes = require('../../routes.json');
Router.setRoutingData(routes);

export {Router};
